<!--
  UserMenu Component
  Avatar + dropdown with settings and logout.
-->
<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { navigate } from 'svelte-routing';
  import { authStore } from '../../auth';
  import { Settings, LogOut } from 'lucide-svelte';

  let open = false;
  // Google profile photo URLs expire (404) — fall back to the initial.
  let pictureFailed = false;

  function toggle() {
    open = !open;
  }

  function close() {
    open = false;
  }

  function handleSettings() {
    navigate('/settings');
    close();
  }

  function handleLogout() {
    authStore.logout();
    window.location.href = '/login';
  }

  function handleClickOutside(e: MouseEvent) {
    const target = e.target as HTMLElement;
    if (!target.closest('.user-menu')) {
      close();
    }
  }
</script>

<svelte:window on:click={handleClickOutside} />

<div class="user-menu relative">
  <button
    class="flex items-center gap-2 px-2 py-2 rounded hover:bg-surface transition-colors
      bg-transparent border-none cursor-pointer"
    on:click|stopPropagation={toggle}
    aria-expanded={open}
    aria-haspopup="true"
  >
    {#if $authStore?.picture && !pictureFailed}
      <img
        src={$authStore.picture}
        alt={$authStore.name}
        class="w-7 h-7 rounded-full border border-border"
        on:error={() => (pictureFailed = true)}
      />
    {:else}
      <div
        class="w-7 h-7 rounded-full bg-accent flex items-center justify-center text-xs font-semibold text-on-accent"
      >
        {$authStore?.name?.charAt(0)?.toUpperCase() || '?'}
      </div>
    {/if}
    <span class="text-sm text-text-secondary hidden sm:inline">{$authStore?.name}</span>
  </button>

  {#if open}
    <div
      class="absolute right-0 top-full mt-1 w-48 bg-surface border border-border rounded-lg shadow-card z-50 py-1"
    >
      <button
        class="flex items-center gap-2 w-full px-3 py-2 text-sm text-text-secondary
          hover:bg-surface-hover hover:text-text transition-colors bg-transparent border-none cursor-pointer text-left"
        on:click={handleSettings}
      >
        <Settings class="w-4 h-4" strokeWidth={1.5} />
        {$_('nav.settings')}
      </button>
      <div class="mx-2 my-1 border-t border-border"></div>
      <button
        class="flex items-center gap-2 w-full px-3 py-2 text-sm text-error
          hover:bg-error/10 transition-colors bg-transparent border-none cursor-pointer text-left"
        on:click={handleLogout}
      >
        <LogOut class="w-4 h-4" strokeWidth={1.5} />
        {$_('nav.logout')}
      </button>
    </div>
  {/if}
</div>
